import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)

export default {
  install(Vue) {
    Vue.prototype.$copy = function(value) {
      this.$copyText(value).then(() => {
        this.$message.success('复制成功')
      },()=>{
        this.$message.error("复制失败")
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/utils/copy.js